import "%modules%/header/header";
import "%modules%/header-assistance/header-assistance";
import "%modules%/footer/footer";
import "%modules%/companies/companies";
import "%modules%/products/products";
import "%modules%/compensation/compensation";
import "%modules%/get/get";
import "%modules%/about/about";
import "%modules%/rating/rating";
import "%modules%/reviews/reviews";
import "%modules%/talk/talk";
import "%modules%/download/download";
import "%modules%/faq/faq";
import "%modules%/ceo/ceo";
import "%modules%/loading/loading";
import "%modules%/modal/modal";
import "%modules%/about-assistance/about-assistance";
import "%modules%/benefits-assistance/benefits-assistance";
import "%modules%/for-who/for-who";
import "%modules%/companies-insurance/companies-insurance";
